<template>
  <div>
    <CollapseCard id="collapse-1" :visible="true">
      <template #header>نمایش نمایه</template>
      <template #body>
        <b-row class="margin-0">
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
        </b-row>
      </template>
    </CollapseCard>
    <CollapseCard id="collapse-2" :visible="true" accordion="second-accordion">
      <template #header>نمایش نمایه</template>
      <template #body>
        <b-row class="margin-0">
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
        </b-row>
      </template>
    </CollapseCard>
    <CollapseCard id="collapse-3" :visible="true" accordion="three-accordion">
      <template #header>نمایش نمایه</template>
      <template #body>
        <b-row class="margin-0">
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
          <b-col cols="12" class="padding-0 flex-between">
            <div class="flex-start">
              <Checkbox
                :label="$lang.profileImage"
                :value="form.profileImage"
                name="profileImage"
                hoverClass=""
                @input="input"
              />
              <span
                class="color-complementary-200 margin-top--10 cursor--pointer icon-hover"
              >
                <mdicon name="pencil-outline" size="16" />
              </span>
            </div>
            <Switchbox
              :value="form.profileImage"
              name="profileImage"
              hoverClass=""
              boxClass="flex-between"
              :showStateText="true"
              :checkedStateText="$lang.required"
              :uncheckedStateText="$lang.required"
              @input="input"
            />
          </b-col>
        </b-row>
      </template>
    </CollapseCard>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Checkbox, Switchbox } from "@/components/re-design/forms";
import CollapseCard from "@/components/re-design/collapse-card/CollapseCard.vue";

export default {
  mixins: [inputMixin],
  components: { Checkbox, Switchbox, CollapseCard },
  data() {
    return {
      form: {
        profileImage: false,
      },
    };
  },
};
</script>
